import { http } from './_http';
import { logWebHrError } from "@/core/logger/log-wrapper";

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function setFormSubmission(
  tenantId,
  onboardingId,
  documentId,
  payload,
  submissionId = null
) {
  try {
    const httpClient = submissionId ? http.put : http.post;

    const { data } = await httpClient(
      `/tenants/${tenantId}/onboardings/${onboardingId}/documents/${documentId}/submissions${
        submissionId ? `/${submissionId}` : ''
      }`,
      payload
    );

    return data.data;
  } catch (e) {
    logWebHrError({
      message: 'Failed to set submission form',
      source: 'set-form-submission',
      metadata: {
        tenantId,
        onboardingId,
        documentId,
        submissionId,
        hasPayload: Boolean(payload),
      },
      error: e,
    });

    throw e;
  }
}
